const shareBtnClass = 'js-share-toggle';

document.addEventListener('click', e => {
	const target = e.target;
	if (target.classList.contains(shareBtnClass)) {
		toggleShare(target);
	}
});

function toggleShare(btn) {
	const parent = btn.parentNode;
	parent.classList.toggle('is-open');
}
